import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Service de documentation
 */
@Injectable({
  providedIn: 'root'
})
export class DocumentationService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Lister les documentations
     */
    lister() {
        return this.http.get(`api/documentation/lister`).pipe(map((retour: any[]): any[] => { return retour }));
    }

    /**
     * Rechercher les documentations
     * @param recherche
     */
    rechercher(recherche: string) {
        let httpParams = new HttpParams().set('Recherche', recherche);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/documentation/rechercher`, options).pipe(map((retour: any[]): any[] => { return retour }));
    }

    /**
     * Paginer les documentations
     * @param recherche
     * @param filtrerLangue
     * @param indice
     * @param nombreElements
     */
    paginer(recherche: string, filtrerLangue: boolean, indice: number, nombreElements: number) {
        let httpParams = new HttpParams()
            .set('Recherche', recherche)
            .set('FiltrerLangue', filtrerLangue.toString())
            .set('Indice', indice.toString())
            .set('NombreElements', nombreElements.toString());
        let options = {
            params: httpParams
        };
        return this.http.get(`api/documentation/paginer`, options).pipe(map((retour: any): any => { return retour }));
    }
}
